import Vue from "vue";
import App from "./App.vue";
import { beforeCreateVueInstance, initializeVueWidget } from "@/widgets/shared/mixins/WidgetBeforeCreateMixin";
import { createStore } from "@/widgets/agenda/store";

//cross-browser compatibility
import "document-register-element/build/document-register-element";

initializeVueWidget(Vue);

Vue.customElement("meeting-app-widget", App, {
  shadow: true,
  props: [
    "slug",
    "componentId",
    "token",
    "accessCode",
    "locale",
    "lpMode",
    "hideSessionTime",
    "hideDays",
    "showLiveIndicator",
    "pageSize",
    "hideLiveStreamButtons",
    "customSponsors",
    "preselectedPathIds",
    "preselectedPlaceIds",
    "showcaseMode",
    "questionsDisabled",
    "lpTheme",
    "lpFont",
    "customCss",
    "hidePaths",
    "highlightedSessionIds",
  ],
  beforeCreateVueInstance: beforeCreateVueInstance({
    store: createStore(),
  }),
});
